import { useMemo } from 'react';

import { chunkBy } from '@ui-furniture/lib/utils';

import { Message } from '../types/message';
import { MessageGroup } from '../types/message-group';

export const useGroupedMessages = (messages: Array<Message>) => {
  const groupedMessages = useMemo<Array<MessageGroup>>(
    () =>
      chunkBy(messages, (message) => message.profile).map((messageGroup) => {
        const message = messageGroup[0]!;
        switch (message.profile) {
          case 'bot':
            return {
              side: 'left',
              messages: messageGroup,
            } as const;
          case 'user':
            return {
              side: 'right',
              messages: messageGroup,
              restore: message.restore,
            } as const;
          default:
            throw new Error(`unrecoginsed profile`);
        }
      }),
    [messages]
  );

  return groupedMessages;
};
